import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Nps } from '@core/interfaces/nps';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class NpsService {
  private getUrl = `${environment.THE_MIRROR_URL}/nps/cmms/responses/latest`;
  private postUrl = `${environment.THE_MIRROR_URL}/nps/cmms/responses`;

  constructor(
    private readonly http: HttpClient,
  ) {}

  public async getNps(): Promise<Nps | null> {
    try {
      return await this.http.get<Nps>(this.getUrl).toPromise();
    } catch (err) {
      const error = err as HttpErrorResponse;
      if (error.status === 404) { return null; }
      throw err;
    }
  }

  public async postNps(value: number, comment: string): Promise<void> {
    await this.http.post(this.postUrl, { value, comment }).toPromise();
  }
}
